import React, { useEffect, useState } from "react";
import styles from "./ClassDetail.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  ErrorMsg,
  CheckboxSelector,
} from "@onegovbugs/onegov-react-components";
import { storeLicenceClass, getLicenceClasses, process2FA, createApplication } from "../../../redux/actions";
import { hasAnyValue, validate, scrollToError } from "../../../utils/Validation";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import { Flora_Fauna_Licence_Type } from "../../../constants";

const ClassDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch();

  const twoFA = useSelector((state) => state.twoFA);
  const twoFAVerified = twoFA && twoFA.data && twoFA.data.firstName && twoFA.data.firstName != "" ? true : false;
  
  const application = useSelector((state) => state.application);
  const referenceData = useSelector((state) => state.referenceDataDetail);
  const optionsLicenceClasses =
    referenceData && referenceData.licenceClasses
      ? referenceData.licenceClasses
      : [];

  const [selectedClasses, setClass] = useState(
    referenceData && referenceData.selectedClasses
      ? referenceData.selectedClasses
      : null
  );

  const CheckIfTwoFAVerified = (props) => {
    if (twoFAVerified) {
        props.history.push("./dashboard");
    } else {
      dispatch(
        process2FA((TwoFaUrl) => {
          sessionStorage["nativespeciesTwoFASource"] = "class-detail";
          window.location = TwoFaUrl;
        })
      );
    }
  };

  useEffect(() => {
    dispatch(getLicenceClasses());
  }, [dispatch]);

  const storeData = () => {
    dispatch(
      storeLicenceClass({
        selectedClasses,
      })
    );
  };

  const validators = [
    {
      fieldName: "selectedClasses",
      fieldValue: selectedClasses,
      isValid: (v) => hasAnyValue(v),
    },
  ];
  console.log(validators);

  const [errors, setErrors] = useState({
    selectedClasses: false,
  });

  const [showErrors, setShowErrors] = useState(false);

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          <label>
            Select the licence classes you are applying for (one or more classes may be chosen)
          </label>
          <br />
          <CheckboxSelector
            onSelectionChange={(v) => {
              setClass(v);
              setShowErrors(false);
            }}
            initialValue={selectedClasses}
            options={optionsLicenceClasses}
            className={styles.extraMargins}
          />
        </div>
      </div>
      {errors.selectedClasses && showErrors ? (
        <div className={"row"}>
          <div className={`col-6 ${styles.errorContainer}`}>
            <ErrorMsg 
              type={"error"}
              description={"Please make a selection."}
            />
          </div>
        </div>
      ) : null}
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData();
                setShowErrors(false);
                if (!application.applicationNo) {
                  dispatch(
                    createApplication(() => {
                      CheckIfTwoFAVerified(props);
                    }, Flora_Fauna_Licence_Type)
                  );
                } else {
                  CheckIfTwoFAVerified(props);
                }
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <ClassDetail {...props} />);
